import React from 'react';

/**
 * The "actual / target" value pair, coloured by pass/fail. Pass/fail is
 * backend-computed and passed in as `isPassed` — this component never derives it
 * from actual vs target. When `isPassed` is undefined (status unknown) the text
 * is left neutral. Shared by BonusExpectationCell (board grid) and the sub-period
 * fact table so the pair renders identically in both.
 */
const ExpectationValue = ({
  actual,
  target,
  isPassed,
}: {
  actual: string | number;
  target: string | number;
  isPassed?: boolean;
}) => {
  const color =
    isPassed === undefined
      ? undefined
      : isPassed
        ? 'var(--color-status-success)'
        : 'var(--color-status-danger)';

  return <span style={{ color }}>{`${actual} / ${target}`}</span>;
};

export default ExpectationValue;
